export const firstAndLastName = (fullName) => {
  if (!fullName) {
    return { firstName: '', lastName: '' };
  }
  var firstName = fullName.split(' ').slice(0, -1).join(' ');
  var lastName = fullName.split(' ').slice(-1).join(' ');

  return { firstName, lastName };
};

export const snakeToCamelCase = (str) =>
  str
    .toLowerCase()
    .replace(/([-_][a-z])/g, (group) =>
      group.toUpperCase().replace('-', '').replace('_', '')
    );

export const camelCaseToSentence = (str) => {
  const result = str.replace(/([A-Z])/g, ' $1');
  const sentence = result.charAt(0).toUpperCase() + result.slice(1);
  return sentence;
};

export const position = (place) => {
  const strPlace = place.toString();
  const lastDigit = strPlace.slice(-1);
  const lastTwoDigits = strPlace.slice(-2);

  if (lastTwoDigits === '11' || lastTwoDigits === '12' || lastTwoDigits === '13') {
    return `${place}th`;
  }

  if (lastDigit === '1') return `${place}st`;
  if (lastDigit === '2') return `${place}nd`;
  if (lastDigit === '3') return `${place}rd`;

  return `${place}th`;
};

export const isJSONParsable = (jsonValue) => {
  if (typeof jsonValue !== 'string') {
    return false;
  }
  try {
    var json = JSON.parse(jsonValue);
    return typeof json === 'object';
  } catch (error) {
    return false;
  }
};

export const spinner = (
  color = '#00778B'
) => `<span class="button-loader MuiCircularProgress-root MuiCircularProgress-indeterminate MuiCircularProgress-colorPrimary css-1q7nima-MuiCircularProgress-root" 
role="progressbar" style=" margin-left: 10px; width: 17px; height: 17px; color: ${color} !important">
  <svg class="MuiCircularProgress-svg css-1idz92c-MuiCircularProgress-svg" viewBox="22 22 44 44">
    <circle class="MuiCircularProgress-circle MuiCircularProgress-circleIndeterminate css-176wh8e-MuiCircularProgress-circle" cx="44" cy="44" r="20.2" 
    fill="none" stroke-width="3.6">
    </circle>
  </svg>
</span>`;

export const capitalizeFirstLetter = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};


export const ErrorMessages = {
  'user is blocked' : 'This account is deactivated, please contact <a href="#">registry@pkdcure.org</a>'
};
